module.exports = __webpack_public_path__ + "img/ic_txt.6c98c9ae.svg";